module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/madison-ferraro-93f4b7dcabd7e9bc93b3fb79b69c598b.jpg";